// All-Access-Hub Prompt Injection Templates

export const HUB_PROMPTS = {
    /**
     * Appends strict LLM rules to the bottom of the fetched RSS markdown block.
     * Prevents hallucination and forces source citations.
     */
    NEWS_INJECTION_BLOCK: (contextBlock: string, recencyNote: string) => `

---
${contextBlock}
${recencyNote}

**Instructions for AVI**: 
Use the news context above to enrich your response with specific, up-to-date information. 
Reference actual headline titles, sources, and key facts directly. If multiple topics are present, weave them together naturally.
Do NOT fabricate any articles, prices, or statistics not shown above.
After answering, offer to dig deeper on any of the topics. Keep your tone conversational and helpful.
---
`,

    /**
     * Lists all available topics to the LLM so it knows what it is capable of fetching.
     */
    TOPIC_DISCOVERY: (formattedLines: string[]) => `\n\n### TOPICS I CAN FETCH LIVE NEWS FOR:\n${formattedLines.join('\n')}\n`
};
